export const initialState = () => ({
  origin: "",
  loading: {
    show: false,
    message: ""
  },
  orderUuid: "",
  rules: {
    shouldBypassCoverage: false
  },
  indexStepsAlreadyVisited: 1,
  previousRoute: "",
  coverageStatus: null,
  customerType: null
})
